import styled, { css } from 'styled-components'
import { COLORS } from 'utils'

export interface IIconContainer {
  selected?: boolean
  isOpen?: boolean
}
export const IconContainerCustom = styled.div<IIconContainer>`
  background: ${({ selected }) => (selected ? COLORS.primary : COLORS.white)};
  width: 2.9375rem;
  height: 2.9375rem;
  border: 0.1rem solid ${COLORS.gray};
  box-shadow: 0px -1px 10px rgba(50, 50, 71, 0.12),
    0px 1px 4px rgba(50, 50, 71, 0.12);
  border-radius: 0.9375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  ${({ isOpen }) =>
    !isOpen &&
    css`
      margin-left: 1.2rem;
    `}
  .icon_drawer {
    fill: ${({ selected }) => selected && COLORS.blueFonts};
    stroke: ${({ selected }) => selected && COLORS.blueFonts};
  }

  .icon_drawer path {
    fill: ${({ selected }) => selected && COLORS.blueFonts};
    stroke: ${({ selected }) => selected && COLORS.blueFonts};
  }
`
